/**
 * [getTrackingCollectionAttributes]
 * pluck collection id and slug info from a section
 * or subsection searchConfig
 *
 * @param   {Object} section      The section or subsection.
 * @returns {Object}
 */

export const getTrackingCollectionAttributes = (section) => {
  const collectionAttr = { collection_id: null, collection_slug: null };

  if (section?.searchConfig?.collectionId) {
    collectionAttr.collection_id = section?.searchConfig?.collectionId;
    collectionAttr.collection_slug = section?.searchConfig?.collectionId;
  } else if (
    !section?.searchConfig?.collectionId &&
    section?.searchConfig?.filterKey &&
    section?.searchConfig?.filterValue
  ) {
    const filterKey: string = section?.searchConfig?.filterKey?.toLowerCase();
    const filterValue: string = section?.searchConfig?.filterValue;
    collectionAttr.collection_id = `${filterKey}/${filterValue}`;
    collectionAttr.collection_slug = `${filterKey}/${filterValue}`;
  }

  return collectionAttr;
};
